import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Get Down with the Get Down',
  date: new Date(2023, 7, 6),
  img: '/img/canadian.jpeg',
  tracks: [
    {
      title: 'Sugar Sweets',
      src: '/songs/2023-08-06/sugar_sweets.mp3',
    },
    {
      title: 'Building Blocks',
      src: '/songs/2023-08-06/building_blocks.mp3',
    },
    {
      title: 'Rhombus Rumpus',
      src: '/songs/2023-08-06/rhombus_rumpus.mp3',
    },
    {
      title: 'Unintended Consequences',
      src: '/songs/2023-08-06/unintended_consequences.mp3',
    },
    {
      title: 'Echosplasm',
      src: '/songs/2023-08-06/echosplasm.mp3',
    },
    {
      title: 'Underground Sound',
      src: '/songs/2023-08-06/underground_sound.mp3',
    },
    {
      title: 'Talk Is Cheap',
      src: '/songs/2023-08-06/talk_is_cheap.mp3',
    },
    {
      title: 'Scary Story',
      src: '/songs/2023-08-06/scary_story.mp3',
    },
    {
      title: 'How it got to be This Way',
      src: '/songs/2023-08-06/how_it_got_to_be_this_way.mp3',
    },
    {
      title: 'Living in a Cave in the Forest',
      src: '/songs/2023-08-06/living_in_a_cave_in_the_forest.mp3',
    },
    {
      title: 'Hosing off the Northen Border',
      src: '/songs/2023-08-06/hosing_off_the_northern_border.mp3',
    },
    {
      title: 'Tea Time',
      src: '/songs/2023-08-06/tea_time.mp3',
    },
    {
      title: 'Free Werner Herzog',
      src: '/songs/2023-08-06/free_werner_herzog.mp3',
    },
    {
      title: 'Roger That: The Season Finale',
      src: '/songs/2023-08-06/rodger_that_season_finale.mp3',
    },
    {
      title: 'Foregone Conclusion',
      src: '/songs/2023-08-06/foregone_conclusion.mp3',
    },
  ]
}
export default album;